import { BundleJson } from '../../../../types/bundleTypes';

const isAssignedCourierName = (
  loweredCaseSearchPhrase: string,
  bundle: BundleJson
) => {
  return (
    bundle.assignedCourierName &&
    bundle.assignedCourierName?.toLowerCase().includes(loweredCaseSearchPhrase)
  );
};

const isBundleId = (loweredCaseSearchPhrase: string, bundle: BundleJson) => {
  return bundle.id.toString().includes(loweredCaseSearchPhrase);
};

const isBundleShelfId = (
  loweredCaseSearchPhrase: string,
  bundle: BundleJson
) => {
  return bundle.shelfId?.toLowerCase().includes(loweredCaseSearchPhrase);
};
const isAssignedCourierPoneNumber = (
  loweredCaseSearchPhrase: string,
  bundle: BundleJson
) => {
  return (
    bundle.assignedCourierPhoneNumber?.length > 0 &&
    bundle.assignedCourierPhoneNumber?.startsWith(loweredCaseSearchPhrase)
  );
};

const isAllOrMatchingRegion = (selectedRegion, bundle: BundleJson) => {
  return selectedRegion === 'ALL' || selectedRegion === bundle.region;
};

export const filterBundlesBySearchPhrase = (
  bundles: BundleJson[],
  searchPhrase: string,
  region
) => {
  const loweredCaseSearchPhrase = searchPhrase.toLowerCase();
  return bundles.filter(
    bundle =>
      isAllOrMatchingRegion(region, bundle) &&
      (isAssignedCourierName(loweredCaseSearchPhrase, bundle) ||
        isBundleId(loweredCaseSearchPhrase, bundle) ||
        isBundleShelfId(loweredCaseSearchPhrase, bundle) ||
        isAssignedCourierPoneNumber(loweredCaseSearchPhrase, bundle))
  );
};
